import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB7yzbn4HNUeKCuG_y8zs_RvEd-mr3CtKk",
  authDomain: "skillzypro-3fe6c.firebaseapp.com",
  projectId: "skillzypro-3fe6c",
  storageBucket: "skillzypro-3fe6c.firebasestorage.app",
  messagingSenderId: "1068870615532",
  appId: "1:1068870615532:web:3b4b8c0ea55577529840c9",
  measurementId: "G-LN8MXZW11D"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
